import * as React from 'react';
import { formatLanguage } from './formatter';
import { cn } from '../utils';
import { CopyButton } from './CopyButton';

interface ToolbarProps {
  language?: string;
  tabs?: string[];
  active?: string;
  setActive?: (language: string) => void;
}

export const Toolbar = ({
  active,
  setActive,
  language,
  tabs,
}: ToolbarProps) => {
  const isMulti = tabs && Array.isArray(tabs);
  return (
    <div className="code-util absolute flex align-center justify-between">
      <div
        className={cn(['language', isMulti ? 'flex align-center' : undefined])}>
        {isMulti && setActive && active
          ? tabs.map((t) => (
              <button
                key={t}
                className={t === active ? 'active' : undefined}
                onClick={() => setActive(t)}>
                {formatLanguage(t)}
              </button>
            ))
          : language
          ? formatLanguage(language)
          : null}
      </div>
      <div className="copy">
        <CopyButton />
      </div>
    </div>
  );
};
